<template>
	<div class="form filters">
		<div v-if="isViewportSmall">
			<div class="grid-1">
				<div class="col" v-for="filter in value" :key="filter.name">
					<Dropdown>
						<template #btn>
							<div class="bp-dropdown__btn-text">
								{{ filter.displayName }}
								<span
									class="filters__filter-badge"
									v-if="hasActiveFilters(filter)"
								>
									{{ hasActiveFilters(filter) }}
								</span>
							</div>
						</template>
						<template #body>
							<ul>
								<li
									v-for="filteritem in filter.values"
									:key="filteritem.displayName"
								>
									<label class="checkbox">
										<input
											type="checkbox"
											v-model="filteritem.value"
											@change="$emit('update', value)"
										/>
										<span class="checkbox__checkmark"></span>
										{{ translate(filteritem.displayName) }}
									</label>
									<span class="filters__filter-amount">
										({{ filteritem.count }})
									</span>
								</li>
							</ul>
						</template>
					</Dropdown>
				</div>
			</div>
		</div>
		<div v-if="!isViewportSmall">
			<fieldset v-for="filter in value" :key="filter.name">
				<legend>{{ filter.displayName }}</legend>
				<ul class="ul--nostyling form">
					<li
						class="filter"
						v-for="filteritem in filter.values"
						:key="filteritem.displayName"
					>
						<label class="checkbox">
							<input
								type="checkbox"
								v-model="filteritem.value"
								@change="$emit('update', value)"
							/>
							<span class="checkbox__checkmark"></span>
							{{ translate(filteritem.displayName) }}
						</label>
						<span class="filters__filter-amount">
							({{ filteritem.count }})
						</span>
					</li>
				</ul>
			</fieldset>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import Dropdown from "./../../../shared/script/vue/Dropdown.vue";

const props = defineProps({
	value: {
		type: Array,
		default: () => []
	}
});

const emit = defineEmits(['update']);

const screenSize = ref('');

onMounted(() => {
	screenSize.value = utilities.getSize();
	utilities.emitter.on("responsive/sizechange", (size) => {
		screenSize.value = size;
	});
});

onBeforeUnmount(() => {
	utilities.emitter.off("responsive/sizechange");
});

const isViewportSmall = computed(() => {
	return ["xsmall", "small", "smallx"].includes(screenSize.value);
});

const hasActiveFilters = (filter) => {
	const activeFilters = filter.values.filter(filterItem => filterItem.value == true);
	return activeFilters.length;
};

const translate = (value) => {
	if (value == "True") {
		return "Ja";
	} else if (value == "False") {
		return "Nej";
	} else {
		return value;
	}
};
</script>
